import IGoogleMapPosition from '../../types/IGoogleMapPosition';

const buildMarkerBounds = (positions: IGoogleMapPosition[]): google.maps.LatLngBounds => {
  const markerBounds: google.maps.LatLngBounds = new google.maps.LatLngBounds();

  positions?.forEach((position) => {
    markerBounds.extend(position);
  });

  return markerBounds;
};

export default buildMarkerBounds;
